var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1276+",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross_icon",
    transform: "translate(7.000000, 7.000000) scale(1, -1) translate(-7.000000, -7.000000) ",
    fill: "#8D8E97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.748503,0.256 C14.0838323,0.597333333 14.0838323,1.152 13.748503,1.51466667 L8.341,6.999 L13.748503,12.4853333 C14.0558882,12.8177778 14.0815037,13.3115556 13.8253493,13.6544568 L13.748503,13.744 C13.4131737,14.0853333 12.8473054,14.0853333 12.511976,13.744 L12.511976,13.744 L7,8.13333333 L1.48802395,13.744 C1.13173653,14.0853333 0.586826347,14.0853333 0.251497006,13.744 C-0.0838323353,13.4026667 -0.0838323353,12.848 0.251497006,12.4853333 L0.251497006,12.4853333 L5.64,7 L0.251497006,1.51466667 C-0.0838323353,1.152 -0.0838323353,0.597333333 0.251497006,0.256 C0.586826347,-0.0853333333 1.13173653,-0.0853333333 1.48802395,0.256 L7,5.86666667 L12.511976,0.256 C12.8473054,-0.0853333333 13.4131737,-0.0853333333 13.748503,0.256 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGray);
export default __webpack_public_path__ + "static/media/close-icon-gray.7970fb878b00ace7d4a8bcf7ee465c39.svg";
export { ForwardRef as ReactComponent };